module.exports = __webpack_public_path__ + "img/solid-line.feba727f.svg";